const googleApi = window.google;

export default googleApi;
